import useLayoutStore, { LeftTab } from "@/store/zustand/layoutStore";
import { ArrowUpRight, Info } from "lucide-react";
import AnimatedLogoCloud from "./LogoCloud";
import { Link } from "react-router";

const SupabaseCard = () => {
  const setNewLayout = useLayoutStore((state) => state.setNewLayout);

  const navigateToSupabasePanel = () => {
    setNewLayout(LeftTab.SupabaseConnect);
  };

  return (
    <div className="px-[25px] w-full">
      <AnimatedLogoCloud />
      <p className="text-sm text-center">
        Connect your app to third-party services like payments, messaging, and
        more.
      </p>
      <Link to="https://tempolabsinc.mintlify.app/MCP/overview" target="_blank">
        <div className="flex text-sm justify-center items-center hover:bg-[#1F1F22] hover:text-white hover:cursor-pointer gap-1 text-center p-1 border rounded-md font-medium my-3">
          Learn More
          <ArrowUpRight className="w-5 h-5" />
        </div>
      </Link>
      <div className="bg-secondary py-2 px-3 rounded-lg flex gap-2 mt-6">
        <Info className="min-w-[12px] min-h-[12px] w-[12px] h-[12px] text-[#9F9FA4] mt-[2px] self-start" />
        <div className="flex flex-col gap-2">
          <p className="text-xs text-[#9F9FA4]">
            MCP apps are built ontop of Supabase.{" "}
            <span
              className="text-[#6448EF] font-medium cursor-pointer hover:underline"
              onClick={navigateToSupabasePanel}
            >
              Please connect to get started.
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SupabaseCard;
